export default "__VITE_ASSET__1747e364__"